<template>
  <div id="message" class="full_layout message">
    <div v-if="!isNull">
      <div class="cartTitle">
        <h3>我的消息<span>共3条消息</span></h3>
      </div>
      <div class="message_list_title message_list">
        <el-checkbox class="message_checkbox" :isIndeterminate='isIndeterminate' v-model="checkAll" @change="handleCheckAllChange"></el-checkbox>
        <div class="message_products">标题</div>
        <div class="message_detail">时间</div>
        <div class="message_price">消息</div>
        <div class="message_number">状态</div>
        <div class="message_total">Operate</div>
      </div>
      <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
        <div class="message_list" v-for="(item,index) in 3" :key="index" :class="index==0?'on':''">
          <el-checkbox class="message_checkbox" :label="item">
          </el-checkbox>
          <div class="message_checkbox_detail">
            <div class="message_products">物品已发货
            </div>
            <div class="message_detail">2022-10-09 19:09:14
            </div>
            <div class="message_price">
              <p class="line_txt3">第一款 2021 年 22 帕尼尼 DONRUSS OPTIC NBA 集换式卡盒2021 年 22 帕ONRUSS OPTIC NBA 集换式卡盒</p>
            </div>
            <div class="message_number">未读
            </div>
            <div class="message_total">
              <router-link :to="{path:'/message/item/1'}">View details</router-link>
            </div>
          </div>
        </div>
      </el-checkbox-group>
      <pagination :TotalCount="TotalCount" :ps="ps" @ps='pageSize' @pi='pageIndex' />
    </div>
    <nonull type='message' text="您还没有任何消息" v-if="isNull" />
  </div>
</template>
<script>
import Nonull from '@/components/nonull'
import Pagination from '@/components/pagination'
export default {
  name: 'message',
  components: { Pagination, Nonull },
  data() {
    return {
      list: [1, 2],
      isNull: false,
      checkedCities: [],
      checkAll: false,
      isIndeterminate: false,
      ps: 24, //pagesize
      pi: 1, //pageindex
      TotalCount: 200
    }
  },
  mounted() {},
  created() {},
  methods: {

    // 全选
    handleCheckAllChange(val) {
      this.checkedCities = val ? this.list : [];
      this.isIndeterminate = false;
      //this.SetTotal(this.checkedCities)
    },
    // 单选
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.list.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.list.length;
      //this.SetTotal(value)
    },
    // 每页几条
    pageSize(val) {
      this.ps = val
      //this.getDetailList();

    },
    // 页码
    pageIndex(val) {
      this.pi = val
      //this.getDetailList();
    }
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../../static/css/pay.css";

</style>



// WEBPACK FOOTER //
// src/pages/message/index.vue